import React from 'react';
import { motion } from 'framer-motion';
import { FileClockIcon, SearchIcon, PhoneOffIcon, CalendarX2Icon, UsersIcon, ShieldQuestionIcon } from 'lucide-react';
const painPoints = [{
  icon: FileClockIcon,
  title: 'Endless Document Drafting',
  description: 'Hours wasted on repetitive contracts, motions, and pleadings that an AI could do in seconds.'
}, {
  icon: SearchIcon,
  title: 'Legal Research Bottlenecks',
  description: 'Time-consuming research that delays cases and relies on expensive tools.'
}, {
  icon: PhoneOffIcon,
  title: 'Lost Client Leads',
  description: 'New inquiries slipping through the cracks due to slow manual follow-up.'
}, {
  icon: CalendarX2Icon,
  title: 'Deadline & Calendar Chaos',
  description: 'Living in constant fear of missing a critical deadline, risking malpractice.'
}, {
  icon: UsersIcon,
  title: 'Paralegal Payroll Pressure',
  description: 'The endless cycle of hiring, training, and managing expensive staff who still get bogged down.'
}, {
  icon: ShieldQuestionIcon,
  title: 'AI Uncertainty & Risk',
  description: 'Hesitancy to adopt new tools due to fears of hallucinations, errors, and confidentiality breaches.'
}];
export function ProblemSection() {
  return <section className="bg-off-white py-20 md:py-28" data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-128">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-6" data-id="element-129">
            Your Firm Is Leaking Profit.{' '}
            <span className="text-blue-accent" data-id="element-130">You Feel It Every Day.</span>
          </h2>
          <p className="text-lg md:text-xl text-charcoal/70 max-w-3xl mx-auto" data-id="element-131">
            You became a lawyer to win cases, not to drown in administrative
            quicksand. Yet, most of your day is spent on low value tasks that
            drain your time and your firm's bank account.
          </p>
        </motion.div>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-132">
          {painPoints.map((point, index) => <motion.div key={point.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm border border-charcoal/5" data-id="element-133">
              <div className="w-12 h-12 bg-navy/5 rounded-lg flex items-center justify-center mb-4" data-id="element-134">
                <point.icon className="w-6 h-6 text-navy" data-id="element-135" />
              </div>
              <h3 className="font-heading text-lg font-bold text-charcoal mb-2" data-id="element-136">
                {point.title}
              </h3>
              <p className="text-charcoal/60 text-sm leading-relaxed" data-id="element-137">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}